import { PDFtype } from "./constants";

export const nameValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[a-zA-ZÀ-ÿ\s]{1,40}$/).test(value)) {
      return "The name is not valid";
    }
    return "";
}

export const companyValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[a-zA-ZÀ-ÿ\s]{1,40}$/).test(value)) {
      return "The company is not valid";
    }
    return "";
  }

export const emailValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/).test(value)) {
      return "The email is not valid";
    }
    return "";
}

export const codCountryValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[0-9]{1,4}$/).test(value)) {
      return "The phone code is not valid";
    }
    return "";
}

export const codAreaValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[0-9]{1,4}$/).test(value)) {
      return "The area code is not valid";
    }
    return "";
}

export const phoneValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[0-9]{1,10}$/).teqqst(value)) {
      return "The phone is not valid";
    }
    return "";
}

export const idPassportValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[0-9]{1,10}$/).test(value)) {
      return "The ID is not valid";
    }
    return "";
}

export const countryValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[a-zA-ZÀ-ÿ\s]{1,40}$/).test(value)) {
      return "The country is not valid";
    }
    return "";
}

export const stateValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[a-zA-ZÀ-ÿ\s]{1,40}$/).test(value)) {
      return "The state is not valid";
    }
    return "";
}

export const cityValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[a-zA-ZÀ-ÿ\s]{1,40}$/).test(value)) {
      return "The city is not valid";
    }
    return "";
}

export const subjectValidator = (value) => {
    if (!value) {
      return "You must choose an option";
    }
    return "";
}

export const messageValidator = (value) => {
    if (!value) {
      return "The field is required";
    } else if (!new RegExp(/^[a-zA-ZÀ-ÿ0-9\s\W]{1,500}$/).test(value)) {
      return "The message is not valid";
    }
    return "";
}

/* Contacto */
export const nameContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[a-zA-ZÀ-ÿ\s]{1,40}$/).test(value)) {
    return "El nombre no es válido";
  }
  return "";
}

export const companyContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[a-zA-ZÀ-ÿ\s]{1,40}$/).test(value)) {
    return "El nombre de la empresa no es válido";
  }
  return "";
}

export const professionContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[a-zA-ZÀ-ÿ\s]{1,40}$/).test(value)) {
    return "El nombre de la profesión no es válido";
  }
  return "";
}

export const emailContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/).test(value)) {
    return "El email no es válido";
  }
  return "";
}

export const idPassportContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[0-9]{1,10}$/).test(value)) {
    return "El DNI o CUIL no es válido";
  }
  return "";
}

export const codCountryContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[0-9]{1,4}$/).test(value)) {
    return "El código del país no es válido";
  }
  return "";
}

export const codAreaContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[0-9]{1,4}$/).test(value)) {
    return "El código de área no es válido";
  }
  return "";
}

export const phoneContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[0-9]{1,10}$/).test(value)) {
    return "El teléfono no es válido";
  }
  return "";
}

export const subjectContactValidator = (value) => {
  if (!value) {
    return "Debes elegir una opción";
  }
  return "";
}

export const educationContactValidator = (value) => {
  if (!value) {
    return "Debes elegir una opción";
  }
  return "";
}

export const siteContactValidator = (value) => {
  if (!value) {
    return "Debes elegir una opción";
  }
  return "";
}

export const filenameContactValidator = (value) => {
  if (!value) {
    return "Debes cargar un CV";
  }
  return "";
}

export const messageContactValidator = (value) => {
  if (!value) {
    return "El campo es requerido";
  } else if (!new RegExp(/^[a-zA-ZÀ-ÿ0-9\s\W]{1,500}$/).test(value)) {
    return "El mensaje no es válido";
  }
  return "";
}
